const doc = [({"da":({"js":({"admin":({"comments":({"add_comment":"Tilføj kommentar", "comment_label":"Kommentar", "comments":"Kommentarer"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;